var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _path9, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertaRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 476.1 482.2",
    style: {
      enableBackground: "new 0 0 476.1 482.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00A25B;}\n\t.st1{fill:#1E4D9C;}\n\t.st2{fill:url(#Brazo_Izquierdo_00000095311644713649352940000005897938377294923142_);}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:url(#Brazo_derecho_00000047758558093832793900000012109503475534338436_);}\n\t.st5{fill:url(#SVGID_00000133519702563109195100000002472374343022132413_);}\n\t.st6{fill:#D6E0EE;}\n\t.st7{opacity:0.15;fill:#FFFFFF;enable-background:new    ;}\n\t.st8{opacity:0.95;fill:#476493;enable-background:new    ;}\n\t.st9{fill:url(#SVGID_00000109745427675818079690000001927241708030014638_);}\n\t.st10{fill:#FFFFFF;}\n\t.st11{fill:#039BD7;}\n\t.st12{fill:#F1871F;}\n\t.st13{opacity:0.5;fill:#282024;enable-background:new    ;}\n\t.st14{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\n\t.st15{fill:#EF802E;}\n\t.st16{opacity:0.5;}\n\t.st17{fill:#282024;}\n\t.st18{opacity:0.4;}\n\t.st19{opacity:0.4;fill:#282024;enable-background:new    ;}\n\t.st20{fill:#F6A030;}\n\t.st21{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st22{fill:#E47219;}\n\t.st23{opacity:0.3;fill:#282024;enable-background:new    ;}\n\t.st24{fill:#FBCA00;}\n\t.st25{opacity:0.6;enable-background:new    ;}\n\t.st26{fill:url(#Antena_00000127024570769451295660000000062481161326951063_);}\n\t.st27{fill:url(#SVGID_00000052807228186694284510000003428872099279130515_);}\n\t.st28{fill:#476493;}\n\t.st29{fill:url(#SVGID_00000130635004159727302470000007913594077005627801_);}\n\t.st30{opacity:0.9;fill:#F3F9FD;enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.4,278.6c0,5.5-0.2,11-0.7,16.4c-8.4,104.8-96.1,187.2-202.9,187.2c-1.9,0-3.7,0-5.5-0.1 c-5.5-0.2-10.9-0.5-16.3-1.1c-16.8-1.8-33.1-5.6-48.4-11.2c-4.2-1.5-8.3-3.2-12.4-5c-19.4-8.6-37.2-20.1-52.8-34c0,0-0.1,0-0.1-0.1 c-0.2-0.2-0.4-0.3-0.6-0.5c-0.8-0.7-1.5-1.4-2.2-2c-0.6-0.5-1.1-1-1.6-1.5c-1-1-2-1.9-3-2.9c-0.1-0.1-0.2-0.2-0.3-0.3 c-1.1-1.1-2.2-2.2-3.3-3.3c-6-6.2-11.6-12.8-16.8-19.7c-0.6-0.8-1.2-1.6-1.8-2.5c-0.5-0.8-1.1-1.5-1.6-2.3 c-0.8-1.2-1.6-2.4-2.4-3.6c-0.5-0.8-1.1-1.6-1.6-2.4c-0.6-0.9-1.2-1.8-1.7-2.7c-0.8-1.2-1.5-2.4-2.2-3.6c-0.5-0.7-0.9-1.5-1.3-2.2 c-0.7-1.2-1.4-2.4-2.1-3.6c-0.7-1.2-1.3-2.4-2-3.6c-0.4-0.7-0.7-1.4-1.1-2c-0.3-0.6-0.6-1.1-0.9-1.7c-0.5-0.9-0.9-1.9-1.4-2.8 c-1.4-2.9-2.8-5.9-4-8.9c-0.7-1.6-1.4-3.3-2-5c-1.3-3.2-2.4-6.4-3.5-9.6c-0.4-1.2-0.8-2.5-1.2-3.7c-0.1-0.4-0.3-0.8-0.4-1.3 c-0.5-1.5-0.9-3.1-1.4-4.6c-0.3-1.1-0.6-2.2-0.9-3.4c-0.2-0.8-0.5-1.6-0.6-2.4c-0.4-1.4-0.7-2.8-1-4.3c-0.2-1.1-0.5-2.2-0.7-3.2 c-0.2-1.1-0.5-2.2-0.7-3.3c-0.1-0.3-0.1-0.6-0.2-0.9c-0.3-1.4-0.6-2.9-0.8-4.3c-0.1-0.5-0.2-1-0.2-1.6c-0.2-0.9-0.3-1.9-0.4-2.8 c-0.2-1-0.3-2-0.4-3c-0.1-0.6-0.2-1.2-0.2-1.8c-0.1-1.1-0.3-2.2-0.4-3.4c-0.1-0.8-0.2-1.6-0.2-2.5c-0.1-0.9-0.2-1.9-0.2-2.8 c0-0.5-0.1-1-0.1-1.5c-0.1-1.4-0.2-2.7-0.2-4.1c-0.1-1.7-0.2-3.5-0.2-5.2c0-1.8-0.1-3.5-0.1-5.2c0-112.5,91.2-203.6,203.6-203.6 c1.8,0,3.5,0,5.2,0.1c1.8,0.1,3.5,0.1,5.2,0.2c1.3,0.1,2.5,0.1,3.8,0.2c1.4,0.1,2.9,0.2,4.3,0.3c1,0.1,1.9,0.2,2.8,0.3 c1.1,0.1,2.2,0.2,3.2,0.4c0.7,0.1,1.4,0.1,2.1,0.2c0.8,0.1,1.6,0.2,2.4,0.3c1.3,0.2,2.6,0.4,3.8,0.6c0.2,0,0.5,0.1,0.7,0.1 c1.6,0.2,3.1,0.5,4.7,0.8c0.2,0.1,0.5,0.1,0.8,0.2c1.2,0.2,2.4,0.5,3.5,0.7c1.1,0.2,2.1,0.4,3.2,0.7c0.2,0,0.3,0.1,0.5,0.1 c1.4,0.3,2.7,0.6,4.1,1c5.1,1.3,10.1,2.8,15,4.4c3.1,1.1,6.2,2.2,9.4,3.4c1.7,0.7,3.5,1.4,5.2,2.1c1.5,0.7,3.1,1.3,4.6,2 c0.4,0.2,0.9,0.4,1.3,0.6c1.2,0.6,2.4,1.1,3.5,1.7c0.3,0.1,0.5,0.2,0.8,0.4c1.3,0.6,2.6,1.3,3.8,1.9c0.5,0.2,0.9,0.5,1.4,0.7 c1,0.5,2,1,2.9,1.6c0.5,0.3,1.1,0.6,1.6,0.9c1.1,0.6,2.2,1.3,3.4,1.9c0.3,0.2,0.6,0.3,0.8,0.5c1.1,0.7,2.3,1.3,3.4,2.1 c0.4,0.2,0.8,0.5,1.2,0.8c0.8,0.5,1.7,1.1,2.5,1.6c0.8,0.5,1.6,1.1,2.4,1.6c1.2,0.8,2.3,1.6,3.5,2.4c1.2,0.8,2.4,1.7,3.5,2.6 c1.8,1.3,3.5,2.6,5.2,4c5.4,4.2,10.5,8.7,15.4,13.4c1.3,1.2,2.5,2.4,3.7,3.6c1.1,1.1,2.2,2.2,3.2,3.4h0c0.2,0.1,0.3,0.3,0.4,0.5 c1.2,1.3,2.4,2.6,3.5,3.9c3.6,4,7,8.1,10.3,12.4c9.1,12,16.9,25,23.2,38.8c0.5,1.2,1,2.3,1.6,3.5c1.4,3.3,2.7,6.6,4,9.9 c5,13.6,8.7,27.9,10.7,42.7c0.5,3.8,1,7.6,1.3,11.5C408.2,267.4,408.4,273,408.4,278.6L408.4,278.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.3,270.6c0,5.3-0.2,10.6-0.6,15.7c-8,100.4-92,179.4-194.5,179.4c-1.8,0-3.5,0-5.3-0.1 c-5.3-0.1-10.5-0.5-15.6-1c-16.1-1.7-31.7-5.4-46.4-10.8c-4-1.5-8-3.1-11.8-4.8c-18.6-8.2-35.6-19.3-50.6-32.6c0,0,0,0-0.1-0.1 c-0.2-0.1-0.3-0.3-0.5-0.5c-0.7-0.6-1.4-1.3-2.1-1.9c-0.5-0.5-1.1-1-1.6-1.5c-1-0.9-1.9-1.8-2.9-2.8c-0.1-0.1-0.2-0.2-0.3-0.3 c-1.1-1-2.1-2.1-3.2-3.2c-5.8-5.9-11.1-12.2-16.1-18.9c-0.6-0.8-1.2-1.6-1.8-2.4c-0.5-0.7-1-1.4-1.6-2.2c-0.8-1.1-1.6-2.2-2.3-3.4 c-0.5-0.8-1-1.5-1.5-2.3c-0.6-0.9-1.1-1.7-1.7-2.6c-0.7-1.1-1.4-2.3-2.1-3.4c-0.4-0.7-0.9-1.4-1.3-2.1c-0.7-1.2-1.4-2.3-2-3.5 c-0.7-1.1-1.3-2.3-1.9-3.5c-0.4-0.7-0.7-1.3-1-2c-0.3-0.5-0.6-1.1-0.9-1.7c-0.5-0.9-0.9-1.8-1.3-2.7c-1.4-2.8-2.6-5.6-3.9-8.5 c-0.7-1.6-1.3-3.1-2-4.8c-1.2-3-2.3-6.1-3.4-9.2c-0.4-1.2-0.8-2.4-1.2-3.5c-0.1-0.4-0.3-0.8-0.4-1.2c-0.4-1.5-0.9-2.9-1.3-4.4 c-0.3-1.1-0.6-2.1-0.9-3.2c-0.2-0.8-0.4-1.5-0.6-2.3c-0.4-1.4-0.7-2.7-1-4.1c-0.2-1-0.5-2.1-0.7-3.1c-0.2-1-0.5-2.1-0.7-3.1 c-0.1-0.3-0.1-0.5-0.1-0.8c-0.3-1.4-0.5-2.7-0.7-4.1c-0.1-0.5-0.2-1-0.2-1.5c-0.2-0.9-0.3-1.8-0.4-2.7c-0.2-1-0.3-1.9-0.4-2.9 c-0.1-0.6-0.2-1.1-0.2-1.7c-0.1-1.1-0.3-2.1-0.4-3.2c-0.1-0.8-0.2-1.6-0.2-2.4c-0.1-0.9-0.2-1.8-0.2-2.7c0-0.5-0.1-1-0.1-1.5 c-0.1-1.3-0.2-2.6-0.2-3.9c-0.1-1.7-0.2-3.3-0.2-5c0-1.7-0.1-3.4-0.1-5c0-107.8,87.4-195.1,195.1-195.1c1.7,0,3.4,0,5,0.1 c1.7,0,3.4,0.1,5,0.2c1.2,0,2.4,0.1,3.6,0.2c1.4,0.1,2.8,0.2,4.1,0.3c0.9,0.1,1.8,0.2,2.7,0.3c1.1,0.1,2.1,0.2,3.1,0.4 c0.7,0,1.4,0.1,2,0.2c0.8,0.1,1.5,0.2,2.2,0.3c1.2,0.2,2.4,0.3,3.6,0.6c0.2,0,0.5,0,0.7,0.1c1.5,0.2,3,0.5,4.5,0.8 c0.2,0,0.5,0.1,0.8,0.2c1.1,0.2,2.2,0.4,3.4,0.7c1,0.2,2,0.4,3,0.7c0.1,0,0.3,0.1,0.5,0.1c1.3,0.3,2.6,0.6,3.9,0.9 c4.9,1.2,9.6,2.7,14.3,4.2c3,1,6,2.1,9,3.3c1.7,0.7,3.3,1.3,4.9,2c1.5,0.6,3,1.3,4.4,1.9c0.4,0.2,0.8,0.4,1.2,0.6 c1.1,0.5,2.2,1.1,3.4,1.6c0.3,0.1,0.5,0.2,0.8,0.4c1.2,0.6,2.5,1.2,3.6,1.9c0.4,0.2,0.9,0.4,1.3,0.7c0.9,0.5,1.9,1,2.8,1.5 c0.5,0.3,1,0.6,1.6,0.9c1.1,0.6,2.1,1.2,3.2,1.9c0.3,0.2,0.5,0.3,0.8,0.5c1.1,0.6,2.2,1.3,3.2,2c0.4,0.2,0.8,0.5,1.2,0.7 c0.8,0.5,1.6,1,2.4,1.5c0.8,0.5,1.6,1,2.3,1.6c1.1,0.7,2.2,1.5,3.3,2.3c1.1,0.8,2.3,1.6,3.4,2.4c1.7,1.2,3.4,2.5,5,3.8 c5.1,4,10.1,8.3,14.7,12.8c1.2,1.1,2.4,2.3,3.6,3.5c1,1.1,2.1,2.1,3.1,3.2h0c0.1,0.1,0.3,0.3,0.4,0.4c1.1,1.2,2.3,2.5,3.4,3.7 c3.5,3.9,6.7,7.8,9.8,11.9c8.7,11.5,16.2,23.9,22.2,37.2c0.5,1.1,1,2.2,1.5,3.4c1.4,3.1,2.6,6.3,3.8,9.5c4.8,13,8.3,26.7,10.2,40.9 c0.5,3.6,0.9,7.3,1.2,11C395.1,260,395.3,265.3,395.3,270.6L395.3,270.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Brazo_Izquierdo_00000091709456892839038400000001067904116811538579_",
    gradientUnits: "userSpaceOnUse",
    x1: -228.9354,
    y1: 694.3312,
    x2: -183.5654,
    y2: 763.2112,
    gradientTransform: "matrix(-0.2585 1.0383 1.2652 0.258 -902.9266 438.9168)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D6E0EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#CBD7E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#B5C4CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ADBDC6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Brazo_Izquierdo",
    style: {
      fill: "url(#Brazo_Izquierdo_00000091709456892839038400000001067904116811538579_)"
    },
    d: " M107.3,396.6c-31.6,50.6-29.7,64.4-49.9,70.5c-2.3,0.7-14.1,4.2-27.2,0.4c-10.4-3.1-17.4-9.6-20.2-13.4 c-17.3-23.1,12.5-67.3,58.9-92.1c8.3-4.5,29.4-18.7,40.7-12.8c4.6,2.4,6,7.3,7,10.8C120.7,375.6,112.1,389,107.3,396.6 L107.3,396.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.1219,
    y1: 339.5453,
    x2: 185.3555,
    y2: 339.5453,
    gradientTransform: "matrix(0.9825 0.1865 0.1865 -0.9825 -201.0703 723.4209)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#FEFEFE",
      stopOpacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#FCFCFD",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#F8F9FA",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#F3F5F7",
      stopOpacity: 0.82
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#ECEFF3",
      stopOpacity: 0.72
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#E4E8ED",
      stopOpacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#DBE0E7",
      stopOpacity: 0.44
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#CFD6E0",
      stopOpacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#C3CBD8",
      stopOpacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFC8D5",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.1,406.6c5.2,4.3,9.8,9,13.9,14.1c4.1,5.1,7.2,10.2,9.1,15.3c0.1,0.4,0,0.8-0.4,0.9 c-0.4,0.1-0.8,0-0.9-0.4c-1.9-4.9-4.8-9.9-8.9-14.9c-4.1-5-8.6-9.7-13.7-13.9c-0.3-0.2-0.3-0.7-0.1-1c0.2-0.2,0.4-0.3,0.7-0.2 C18.9,406.4,19,406.5,19.1,406.6"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Brazo_derecho_00000083799977217815722000000014876805740387092625_",
    gradientUnits: "userSpaceOnUse",
    x1: 675.3615,
    y1: 642.5535,
    x2: 723.5914,
    y2: 728.8936,
    gradientTransform: "matrix(1.0577 0.1617 -0.2496 1.2668 -280.7355 -638.0578)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D6E0EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFC8D5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Brazo_derecho",
    style: {
      fill: "url(#Brazo_derecho_00000083799977217815722000000014876805740387092625_)"
    },
    d: " M260.1,368.3c58.9-9.7,70.9-2.6,84.3-18.9c1.5-1.9,9.4-11.4,10.8-24.9c1.2-10.8-2.2-19.8-4.6-23.9 c-14.6-24.8-66.9-14.4-107.7,18.9c-7.3,6-28.6,19.9-27.5,32.7c0.5,5.2,4.4,8.4,7.3,10.6C235.5,372.6,251.2,369.8,260.1,368.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079454425581017219610000008262643241335586714_",
    gradientUnits: "userSpaceOnUse",
    x1: -1484.3538,
    y1: -627.4821,
    x2: -1455.125,
    y2: -627.4821,
    gradientTransform: "matrix(0.2065 -0.9784 -0.9784 -0.2065 2.7356 -1261.5983)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BFC8D5",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#C3CBD8",
      stopOpacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#CFD6E0",
      stopOpacity: 0.26
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#DBE0E7",
      stopOpacity: 0.44
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#E4E8ED",
      stopOpacity: 0.59
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#ECEFF3",
      stopOpacity: 0.72
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#F3F5F7",
      stopOpacity: 0.82
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F8F9FA",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#FCFCFD",
      stopOpacity: 0.96
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#FEFEFE",
      stopOpacity: 0.99
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079454425581017219610000008262643241335586714_)"
    },
    d: "M303.4,290.1c2,6.4,4.5,12.5,7.7,18.3 c3.1,5.8,6.7,10.5,10.6,14.3c0.3,0.3,0.7,0.3,1,0s0.3-0.7,0-1c-3.8-3.6-7.3-8.3-10.4-13.9c-3.1-5.7-5.6-11.7-7.6-18 c-0.1-0.4-0.5-0.6-0.9-0.5c-0.2,0.1-0.4,0.3-0.5,0.5C303.4,289.9,303.4,290,303.4,290.1"
  })), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Cuerpo_00000098217120779361498660000015179866817547459516_",
    className: "st6",
    d: "M179.3,464.6 c-63.8-7.6-86.6-31.1-86.6-31.1c5.8-32.2,15.5-71.2,30.1-83.5h0c8.1-6.9,18-11.5,21.5-12.7c12.8-4.6,24.1-3.7,31.6-3.8h1.3 c7.5,0.1,18.8-0.8,31.6,3.8c3.5,1.2,15.1,4.2,21.5,12.7c17.6,23.2,29.3,73.6,35.1,104.6C265.5,454.5,230.9,470.8,179.3,464.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Circulo"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M214.9,391.9c4.2,27-17.6,50.1-43.3,45.7c-15.5-2.7-28.1-15.9-30.6-32.3c-4.2-27,17.6-50.1,43.3-45.7 C199.8,362.3,212.3,375.5,214.9,391.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M214.9,393.4c4.2,26.1-17.6,48.5-43.3,44.2c-15.5-2.6-28.1-15.4-30.6-31.2c-4.2-26.2,17.6-48.5,43.3-44.2 C199.8,364.8,212.3,377.6,214.9,393.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103985503129598168350000011616482040321609366_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.975,
    y1: 185.8642,
    x2: 177.975,
    y2: 111.8758,
    gradientTransform: "matrix(1 0 0 -1 0 550)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#039BD7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#077FB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#0D608F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#11476F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#153357"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#182545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#191C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A1A38"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103985503129598168350000011616482040321609366_)"
    },
    d: "M214.9,394.9 c4.2,25.3-17.6,46.9-43.3,42.8c-15.5-2.5-28.1-14.9-30.6-30.2c-4.2-25.3,17.6-46.9,43.3-42.8 C199.8,367.2,212.4,379.5,214.9,394.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 177.6,
    cy: 400.2,
    rx: 26.5,
    ry: 26.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M177.9,417.5l-17.6-26.4l17.6,15.3l21.2-21.8c-4.8-6.7-12.6-11.1-21.5-11.1c-14.6,0-26.5,11.9-26.5,26.6 s11.9,26.6,26.5,26.6s26.5-11.9,26.5-26.6c0-4.7-1.2-9.2-3.4-13L177.9,417.5L177.9,417.5z M177.9,384.5c3.4,0,6.1,2.8,6.1,6.2 s-2.7,6.2-6.1,6.2s-6.1-2.8-6.1-6.2S174.5,384.5,177.9,384.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M214.6,368.8l-15.4,15.8c0.6,0.8,1.1,1.6,1.6,2.5L214.6,368.8z"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M113.3,370.6c-0.3,0.2-0.5,0.6-0.3,1s0.6,0.5,1,0.3c20.7-11.3,41.4-17,62.1-17s41.4,5.7,62.1,17 c0.3,0.2,0.8,0.1,1-0.3s0.1-0.8-0.3-1c-20.9-11.5-41.9-17.2-62.8-17.2S134.3,359.1,113.3,370.6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M309.4,299.6l-5.1,1.5c-2.6,0.8-5.3-0.6-6.1-3.2l-7.5-24l0,0c-0.8-2.5,0.9-5.2,3.8-6.3l4.6-1.3l0.7,2.2 L309.4,299.6L309.4,299.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M309.4,299.6l-5.1,1.5c-2.6,0.8-5.3-0.6-6.1-3.2l-7.5-24l0.6,2c-0.4-1.6,0.1-3.2,1.3-4.4 c0,0.1,0,0.2,0.1,0.3v0l7.5,24c0.8,2.6,3.5,4,6.1,3.2l2.7-0.8L309.4,299.6L309.4,299.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M299.7,268.5l-4.3,1.2c-3,0.9-4.8,3.7-4.1,6.2l-0.6-2l0,0c-0.8-2.5,0.9-5.2,3.8-6.3c0.1,0,0.2-0.1,0.3-0.1 l4.3-1.2L299.7,268.5L299.7,268.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M344.9,311.4l-5.5,1.7l-2.9-9.4l-0.9-3l-1.9-6.1l4.6-1.4l3.7-1.2l0.7,2.2l1.7,5.4l0.8,2.5l0.2,0.8l1.5,5 C347.3,309.2,346.5,310.9,344.9,311.4L344.9,311.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M349.2,345.3c-2.2-0.3-4.5-0.7-6.6-1.2c-6.8-1.5-13.3-3.8-19.4-6.8c-1.7-0.8-3.3-1.7-4.9-2.6l-8.9-29.1 l-1.7-5.5l-0.2-0.7v0c0,0,0-0.1,0-0.1l-0.2-0.6l-1.6-5.3l-0.1-0.5l1.5-0.5l0.9-0.3l1.3-0.4l21.5-6.7l0.1,0.5l2.7,8.9l1.3,4.2 l0.6,2l0.2,0.5l0,0l0.8,2.5l0.7,2.2l0,0.1l0,0.1l2.1,6.9l1.3,4.3l0.3,0.9l1.9,6.2l0,0l0.3,0.9l1.3,4.2l0.3,0.9l1.9,6.2l0,0 l0.3,0.9l1.6,5.2L349.2,345.3L349.2,345.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M313.6,306l9.6,31.3c-1.7-0.8-3.3-1.7-4.9-2.6l-8.9-29.1l-1.7-5.5l-0.2-0.6c0,0,0,0,0,0v0 c0,0,0-0.1,0-0.1l-0.2-0.6l-1.6-5.3l-0.1-0.5l1.5-0.5l0.9-0.3l1.3-0.4l0.1,0.5l2.1,6.9l1,3.3l0,0L313.6,306L313.6,306z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M349.2,345.3c-2.2-0.3-4.5-0.7-6.6-1.2l5.7-1.8L349.2,345.3L349.2,345.3z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M339.3,312.9l-10.5,2.9c-2,0.5-4-0.6-4.5-2.6c0-0.1,0-0.2-0.1-0.3c-0.4-1.9,0.8-3.7,2.6-4.2l10.3-2.9 L339.3,312.9L339.3,312.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M343,325.1l-9.9,2.7c-2,0.5-4-0.6-4.5-2.6c0-0.1,0-0.2-0.1-0.3c-0.4-1.9,0.8-3.7,2.6-4.2l9.7-2.7 L343,325.1L343,325.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M346.7,337.1l-10.5,2.9c-2,0.5-4-0.6-4.5-2.6c0-0.1,0-0.2-0.1-0.3c-0.4-1.9,0.8-3.7,2.6-4.2l10.3-2.9 L346.7,337.1L346.7,337.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M337.2,305.9l-10.3,2.9c-1.8,0.5-3,2.3-2.6,4.1c-0.1-0.2-0.1-0.3-0.2-0.5c0-0.1,0-0.2-0.1-0.3 c-0.4-1.9,0.8-3.7,2.6-4.2l10.3-2.9L337.2,305.9L337.2,305.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M342.8,324.2L342.8,324.2l-1.9-6.2l-9.7,2.7c-1.8,0.5-3,2.3-2.6,4.1c-0.1-0.2-0.1-0.3-0.2-0.5 c0-0.1,0-0.2-0.1-0.3c-0.4-1.9,0.8-3.7,2.6-4.2l9.7-2.7L342.8,324.2L342.8,324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M346.5,336.3L346.5,336.3l-1.9-6.2l-10.3,2.9c-1.8,0.5-3,2.3-2.6,4.1c-0.1-0.2-0.1-0.3-0.2-0.5 c0-0.1,0-0.2-0.1-0.3c-0.4-1.9,0.8-3.7,2.6-4.2l10.3-2.9L346.5,336.3L346.5,336.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M345.3,302.7l-8.8,0.9l-22.7,2.4c-1.5,0.2-3,0-4.4-0.4l-3.7-12.1l29.8-9.3l2.7,8.9l0.3,0.9l4.1,0.1 l1.7,5.4l0.8,2.5L345.3,302.7L345.3,302.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M425.6,295.6c0,0-0.1,0-0.1,0c-0.3,0.1-0.5,0.1-0.8,0.2l-0.8,0l-1,0.1l-17.8,1.1l-1.8,0.1l-58.7,3.5 l-8.9,0.5h0l-22.4,1.3c-0.3,0-0.5,0-0.8,0c-2.3,0-4.3-1.2-5-3.1c0,0,0,0,0,0v0c0,0,0-0.1,0-0.1l-1.8-5.8l-8.1-26.1 c-0.2-0.6-0.2-1.2-0.1-1.8c0.1-0.5,0.2-1.1,0.5-1.6c0.1-0.1,0.1-0.2,0.2-0.4c0.1-0.2,0.3-0.4,0.5-0.6c0.2-0.3,0.5-0.6,0.9-0.8 c0.2-0.2,0.5-0.3,0.7-0.5c0.1-0.1,0.2-0.1,0.4-0.2l68.6-41.4l9.1-5.5l1.5-0.9l15.2-9.2c0,0,0,0,0,0l0.8-0.5l0.7-0.4l0,0 c0,0,0,0,0,0c0.2-0.1,0.5-0.2,0.7-0.3c0,0,0.1,0,0.1,0l0,0l0.3,0.9l0.6,1.9l4.7,15.4c0,0,0,0,0,0l5,16.4l6.7,22.1l5.5,18.3 c0,0,0,0,0,0L425.6,295.6L425.6,295.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M423.2,293.4l-16.2,1l-5.4,0.3c-6.7-9.7-13.4-25-17.1-37c-3.7-11.8-6.4-27.9-6.3-39.7l1.5-0.9l11.6-7 l0.1,0l2.1-1.3l3.4-2l4.4,14.5l0,0l5.1,16.9l6.7,22.1l5.7,18.7v0L423.2,293.4L423.2,293.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M425.5,295.7c-0.3,0.1-0.5,0.1-0.8,0.2L423,296l-17.8,1.1c-7.4-9.4-15-26.5-19.2-39.7 c-3.7-11.9-6.5-28.4-6.3-40.2c0-1.2,0.1-2.4,0.1-3.6l15.2-9.2c0,0,0,0,0,0l1.5-0.9l0,0c0,0,0,0,0,0c0.2-0.1,0.5-0.2,0.7-0.3 l0.3,0.8l0.6,2l4.5,14.9l0,0l5.1,16.9l6.7,22.1l5.7,18.7v0L425.5,295.7L425.5,295.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M398.3,205.8L398.3,205.8l-0.1,0.1l-4.8,2.9l-2.1,1.3l-0.1,0l-11.6,7l-78.2,47.2c-2.4,1.2-3.6,3.6-3,5.7 l-0.9-2.8c-0.2-0.6-0.2-1.2-0.1-1.8c0.1-0.5,0.2-1.1,0.5-1.6c0.1-0.1,0.1-0.2,0.2-0.4c0.1-0.2,0.3-0.4,0.5-0.6 c0.2-0.3,0.5-0.6,0.9-0.8c0.2-0.2,0.5-0.3,0.7-0.5c0.1-0.1,0.2-0.1,0.4-0.2l68.6-41.4l10.7-6.4l15.2-9.2c0,0,0,0,0,0l1.5-0.9 l0,0c0,0,0,0,0,0c0.2-0.1,0.5-0.2,0.7-0.3c0,0,0.1,0,0.1,0l0,0l0.3,0.9L398.3,205.8L398.3,205.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M299.6,265.7C299.6,265.7,299.7,265.6,299.6,265.7L299.6,265.7C299.7,265.6,299.6,265.7,299.6,265.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M398.3,205.8L398.3,205.8l-0.1,0.1l-1.4,0.8l-0.1-0.4l-0.6-2l-0.2-0.5l0.7-0.4l0,0c0,0,0,0,0,0 c0.2-0.1,0.5-0.2,0.7-0.3c0,0,0.1,0,0.1,0l0,0l0.3,0.9L398.3,205.8L398.3,205.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M429,293c-0.9,1.3-2,2.2-3.3,2.6l0,0c0,0-0.1,0-0.1,0c-0.3,0.1-0.5,0.1-0.8,0.2 c-0.6,0.1-1.2,0.1-1.8,0.1c-0.9,0-1.8-0.2-2.8-0.6c-0.5-0.2-1.1-0.4-1.7-0.7l0,0l0,0c-0.1,0-0.2-0.1-0.3-0.1 c-0.2-0.1-0.4-0.2-0.6-0.4c-7.1-4.6-16.3-21.7-21.4-36.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.4-0.3-0.9-0.5-1.4 c-0.1-0.2-0.1-0.5-0.2-0.7c-0.1-0.3-0.2-0.5-0.2-0.8c-0.4-1.4-0.8-2.7-1.2-4.1c-3.8-14.3-5.4-31.9-2.8-40.3 c0.2-0.7,0.5-1.3,0.8-1.9c0-0.1,0.1-0.2,0.1-0.3l0,0c0.2-0.4,0.5-0.8,0.7-1.2c0.4-0.5,0.7-1,1.1-1.4l0,0 c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.1,0.3-0.2,0.4-0.4c0.1-0.1,0.2-0.2,0.3-0.2c0,0,0,0,0,0c0.1-0.1,0.3-0.2,0.4-0.3 c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.2,0.5-0.3,0.8-0.4c0,0,0,0,0,0h0l0,0c0,0,0,0,0,0c0.2-0.1,0.5-0.2,0.7-0.3c0,0,0.1,0,0.1,0 l0,0c9-2.8,23.8,19.8,30.4,41.2c0.6,1.9,1.1,3.8,1.6,5.7c0.1,0.3,0.1,0.6,0.2,0.9c0,0.1,0,0.2,0.1,0.2c0.1,0.3,0.2,0.6,0.2,1 c0.1,0.3,0.2,0.7,0.2,1c0,0.2,0.1,0.3,0.1,0.5c0.1,0.6,0.2,1.1,0.3,1.6c0.1,0.5,0.2,1,0.3,1.5 C433.7,271.7,433.3,286.8,429,293L429,293z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M420.2,295.4c-0.5-0.2-1.1-0.4-1.7-0.7l0,0l0,0c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.4-0.2-0.6-0.4 c-7.1-4.6-16.3-21.7-21.4-36.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.4-0.3-0.9-0.5-1.4c-0.1-0.2-0.1-0.5-0.2-0.7 c-0.1-0.3-0.2-0.5-0.2-0.8c-0.4-1.4-0.8-2.7-1.2-4.1c-3.8-14.3-5.4-31.9-2.8-40.3c0.2-0.7,0.5-1.3,0.8-1.9 c0-0.1,0.1-0.2,0.1-0.3l0,0c0.2-0.4,0.5-0.8,0.7-1.2c8.8,3.9,20.1,22.7,25.7,40.7c0.6,1.9,1.1,3.8,1.6,5.7 c0.1,0.3,0.1,0.6,0.2,0.9c0,0.1,0,0.2,0.1,0.3c0.1,0.3,0.2,0.6,0.2,1c0.1,0.3,0.2,0.7,0.2,1c0,0.2,0.1,0.3,0.1,0.5 c0.1,0.5,0.2,1.1,0.3,1.6c0.1,0.5,0.2,1,0.3,1.5C424.2,274.3,424,288.8,420.2,295.4L420.2,295.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M429.5,250c0.1,0.3,0.1,0.6,0.2,0.9c0,0.1,0,0.2,0.1,0.2c0.1,0.3,0.2,0.6,0.2,1c0.1,0.3,0.1,0.7,0.2,1 c0,0.2,0.1,0.3,0.1,0.5c0.1,0.5,0.2,1.1,0.3,1.6c0.1,0.5,0.2,1,0.3,1.5c2.8,15,2.4,30.1-2,36.3c-0.9,1.3-2,2.2-3.3,2.6l0,0 c0,0-0.1,0-0.1,0c-0.3,0.1-0.5,0.1-0.8,0.2c0,0,0,0,0,0c1.2-0.4,2.2-1.3,3-2.5c4.3-6.2,4.7-21.2,2-36.3 c-0.1-0.5-0.2-1-0.3-1.5c-0.1-0.5-0.2-1.1-0.3-1.6c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.3-0.1-0.7-0.2-1c-0.1-0.3-0.1-0.7-0.2-1 c0-0.1,0-0.2-0.1-0.2c-0.1-0.3-0.1-0.6-0.2-0.9c-0.5-1.9-1-3.9-1.6-5.7c-6.5-20.8-20.5-42.6-29.6-41.4 c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0l0,0c9-2.8,23.7,19.8,30.4,41.2C428.5,246.1,429,248,429.5,250L429.5,250z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M424.4,248.3c0,4.9-3.2,9.5-8.2,11l-3.8,1.1l-13.4,4.1c-1.4-3.2-2.7-6.6-3.8-10.2 c-1.3-4.1-2.2-8.1-2.9-12l13-4l4.1-1.2c6.1-1.9,12.6,1.6,14.4,7.7C424.3,246.1,424.4,247.2,424.4,248.3L424.4,248.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M424.4,248.3c0,4.9-3.2,9.5-8.2,11l-3.8,1.1l-13.4,4.1c-1.4-3.2-2.7-6.6-3.8-10.2 c-1.3-4.1-2.2-8.1-2.9-12l13-4l4.1-1.2c6.1-1.9,12.6,1.6,14.4,7.7C424.3,246.1,424.4,247.2,424.4,248.3L424.4,248.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M423.9,244.9c0.3,1.1,0.5,2.3,0.5,3.4c0,2.2-0.7,4.4-1.8,6.2c0.4-1.2,0.7-2.5,0.7-3.9 c0-1.1-0.2-2.3-0.5-3.4c-1.8-6.1-8.3-9.6-14.4-7.7l-4.1,1.2l-11.6,3.6c-0.1-0.6-0.2-1.2-0.3-1.9l13-4l4.1-1.2 C415.6,235.4,422.1,238.8,423.9,244.9L423.9,244.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M423,296l-17.8,1.1l-60.5,3.6l-8.9,0.5h0l-22.4,1.3c-0.3,0-0.5,0-0.8,0c-2.3,0-4.3-1.2-5-3.1c0,0,0,0,0,0v0 c0,0,0-0.1,0-0.1l-1.8-5.8l-8.1-26.1l0.9,2.8c-0.4-1.5,0.1-3.2,1.3-4.5l7.9,25.2l1.8,5.8c0,0,0,0.1,0,0.1v0c0,0,0,0,0,0 c0.7,1.9,2.7,3.1,5,3.1c0.2,0,0.5,0,0.8,0l22.4-1.3h0l8.9-0.5l60.5-3.6l10.1-0.6c0.2,0.1,0.4,0.3,0.5,0.4 c0.2,0.1,0.4,0.2,0.6,0.4c0.1,0,0.2,0.1,0.3,0.1l0,0l0,0C420,295.4,421.5,295.9,423,296L423,296z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "475.4,280.8 442.6,277.7 440.9,269.3 416.9,269.2 445.7,259.1 448,268.5 476.1,261.8 476,265.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "476,265.2 446.3,271.5 444.3,262.2 416.9,269.2 445.7,259.1 448,268.5 476.1,261.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "474.4,245.2 447.3,247.5 444.7,241 425.1,244.4 447,232 450.3,239.3 472.2,229.6 472.7,233.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "472.7,233.2 449.5,242.2 446.2,234.8 425.1,244.4 447,232 450.3,239.3 472.2,229.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "429.6,219.8 432.9,229.2 402.3,236.5 423.1,223 419.9,214.8 446.6,193.9 447.9,195.7 457.8,209.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "422.5,215.1 425.1,223.6 402.3,236.5 423.1,223 419.9,214.8 446.6,193.9 447.9,195.7  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Cabeza"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Antena_00000113354842429828581140000000779524036707100548_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.7307,
    y1: 406.1052,
    x2: 80.7307,
    y2: 327.5252,
    gradientTransform: "matrix(0.9944 -0.1054 -0.1054 -0.9944 99.0322 414.14)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A1D6E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#8EC2D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#6898C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#4F7EBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4775B8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Antena",
    style: {
      fill: "url(#Antena_00000113354842429828581140000000779524036707100548_)"
    },
    d: "M168.7,26.1 c1.4,13-5.8,24.6-17,29.8l2.3,22.1L134.7,80l-2.3-22.1C120.6,55,111.5,45,110.1,32.3c-1.7-16.3,10-30.4,26.2-32.1 C152.5-1.5,167,9.8,168.7,26.1L168.7,26.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070801067721640638900000016492805311878597051_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.7395,
    y1: 328.892,
    x2: 80.7395,
    y2: 54.3905,
    gradientTransform: "matrix(0.9944 -0.1054 -0.1054 -0.9944 99.0322 414.14)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D6E0EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#CDD8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFCEE3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070801067721640638900000016492805311878597051_)"
    },
    d: "M144.7,78.6C59,87.7-3.1,164.5,6,250.1 l3.1,29c5.2,49.1,49.2,84.6,98.3,79.5l132.5-14c49.1-5.2,84.6-49.2,79.4-98.3l-3.1-29C307.1,131.6,230.3,69.5,144.7,78.6 L144.7,78.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M36.2,276.1c3.2,30.3,30.4,52.3,60.8,49.1L243,309.8c30.3-3.2,52.3-30.4,49.1-60.8l-4.2-39.7 c-4.4-41.7-41.8-72-83.5-67.5L99.5,152.9c-41.7,4.4-72,41.8-67.5,83.5L36.2,276.1L36.2,276.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M32.3,239.5c-4.4-41.9,26-79.6,67.9-84l104.1-11c41.9-4.4,79.6,25.9,84,67.9l4.1,38.8 c3.2,30.6-18.9,58-49.5,61.2L97.6,327.8c-30.6,3.2-58-18.9-61.2-49.5L32.3,239.5L32.3,239.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134928072034157192530000007558998189723117445_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.7385,
    y1: 247.3548,
    x2: 80.7385,
    y2: 85.828,
    gradientTransform: "matrix(0.9944 -0.1054 -0.1054 -0.9944 99.0322 414.14)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1E3D86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#102C43"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134928072034157192530000007558998189723117445_)"
    },
    d: "M33.3,249.2c-4.4-41.9,26-79.6,67.9-84 l104.1-11c41.9-4.4,79.5,25.9,84,67.9l3.1,29.3c3.2,30.6-18.9,58-49.5,61.2L97.6,328c-30.6,3.2-58-18.9-61.2-49.5L33.3,249.2 L33.3,249.2z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M219.3,199.7l3.6-0.4c8.1-0.9,15.3,5,16.1,13l3.4,31.9c0.9,8.1-5,15.3-13,16.1l-3.6,0.4 c-8.1,0.9-15.3-5-16.1-13l-3.4-31.9C205.4,207.8,211.2,200.6,219.3,199.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M93.5,213l3.6-0.4c8.1-0.9,15.3,5,16.1,13l3.4,31.9c0.9,8.1-5,15.3-13,16.1l-3.6,0.4 c-8.1,0.9-15.3-5-16.1-13l-3.4-31.9C79.6,221.1,85.4,213.9,93.5,213z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M241.3,312.7C241.3,312.7,241.3,312.8,241.3,312.7c1.9,10.5,2.4,18,1.6,23l-0.3,1.8 c-0.4,2.5-0.8,4.4-1.1,5.8l-0.3,1.1l1.5-0.2l0.1-0.5c0.4-1.4,0.8-3.4,1.2-5.9l0.3-1.8c0.8-5.3,0.3-12.7-1.6-23.4L241.3,312.7 L241.3,312.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M99.2,327.8C99.2,327.8,99.2,327.8,99.2,327.8c0.3,10.6,1.4,18.1,3.2,22.9l0.6,1.6c0.9,2.4,1.7,4.2,2.3,5.4 l0.5,1l-1.5,0.1l-0.2-0.5c-0.7-1.3-1.5-3.1-2.4-5.5l-0.6-1.6c-1.9-5-2.9-12.4-3.3-23.2C97.8,327.9,99.2,327.8,99.2,327.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M105.9,87.8C73.8,113.5,80,157.1,80,157.6c0,0,0,0,0,0.1l1.4-0.5c-0.5-3.7-5.2-47.3,29.1-71l-2,0.7 L105.9,87.8L105.9,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M184.4,79.4c36.8,18.4,39.9,62.4,39.9,62.8c0,0,0,0,0,0.1l-1.5-0.2c-0.3-3.7-4.8-47.3-43.3-63.3l2.1,0.3 L184.4,79.4L184.4,79.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaRobot);
export default __webpack_public_path__ + "static/media/alerta_robot.6e9ad2893a1bee3913f60c320537cc08.svg";
export { ForwardRef as ReactComponent };